// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3VX3o","content":"styles_content__2Gd0M","checkbox":"styles_checkbox__1a4Gr","checkboxLabel":"styles_checkboxLabel__1KfOA"};